import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { ModeOptimization } from '/screens/';

export default function ModeOptimizationPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight modes, logistics modes, loadsmart mode optimization, freight mode optimization"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Freight Mode Optimization | Loadsmart"
        description="Access instant, dynamic capacity to move your freight — no matter the mode or market."
        canonical="https://loadsmart.com/mode-optimization/"
        openGraph={{
          url: 'https://loadsmart.com/mode-optimization/',
        }}
      />
      <ModeOptimization />
    </>
  );
}
